function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZendesk = function SvgZendesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.964 21.716c7.023 0 12.716-5.693 12.716-12.716H2.25c0 7.023 5.69 12.716 12.714 12.716ZM27.68 50.724V20.02L2.25 50.724h25.43Zm4.192 0c0-7.024 5.693-12.717 12.716-12.717 7.024 0 12.714 5.693 12.714 12.716h-25.43Zm0-41.724v30.703L57.302 9h-25.43Z",
    fill: props.color,
    stroke: props.color
  }));
};
export default SvgZendesk;